import { createContext } from 'react';

const continentContext = createContext();

export default continentContext;
